import { render } from "./priority.vue?vue&type=template&id=60e56a85"
import script from "./priority.vue?vue&type=script&lang=js"
export * from "./priority.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__